// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/MyModal/index.css
// module id = 2375
// module chunks = 0